import { jsx } from '@emotion/core';
import { Button } from '../Button';
import { Input } from './input';
import { Wrapper } from './wrapper';
var withButtonInputStyles = {
  '&[type]': {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }
};
var withButtonButtonStyles = {
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0
};
export var WithButton = function WithButton(_a) {
  var _b = _a.onClick,
      onClick = _b === void 0 ? function () {} : _b,
      onChange = _a.onChange,
      buttonText = _a.buttonText,
      className = _a.className,
      onKeyDownProp = _a.onKeyDown,
      value = _a.value,
      placeholder = _a.placeholder,
      id = _a.id,
      disabled = _a.disabled,
      size = _a.size,
      type = _a.type,
      _c = _a.onEnterPress,
      onEnterPress = _c === void 0 ? function () {} : _c;

  var onKeyDown = function onKeyDown(e) {
    if (e.keyCode === 13 && onClick) {
      onClick();
    }

    if (onKeyDownProp) {
      onKeyDown(e);
    }
  };

  return jsx(Wrapper, {
    className: className
  }, jsx(Input, {
    css: withButtonInputStyles,
    onKeyDown: onKeyDown,
    onChange: onChange,
    value: value,
    placeholder: placeholder,
    id: id,
    disabled: disabled,
    size: size,
    type: type,
    onEnterPress: onEnterPress
  }), jsx(Button, {
    css: withButtonButtonStyles,
    onClick: onClick,
    size: size
  }, buttonText));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Input/withbutton.js
// module id = 952
// module chunks = 0